/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Alert from 'react-bootstrap/Alert';
import ContactForm from "../common/ContactForm"

const Section = ({ websiteBackgroundColor, customPage, themeColor, websiteTextColor, isHomePage = false, businessCode = '' }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [show, setShow] = useState(false);

  const headingStyle = {
    color: customPage?.heading_color || websiteTextColor || themeColor,
    fontFamily: customPage?.heading_font,
    fontSize: `${customPage?.heading_size}px`,
  };
  const subHeadingStyle = {
    color: customPage?.sub_heading_color || websiteTextColor || '#1d2228',
    fontFamily: customPage?.sub_heading_font,
    fontSize: `${customPage?.sub_heading_size}px`,
  };
  const descriptionColor = customPage?.description_color || websiteTextColor || '#515151'
  const ImageUrl = customPage?.image_url
  const headingSecondaryStyle = {
    color: customPage?.heading_color_secondary || websiteTextColor || themeColor,
    fontFamily: customPage?.heading_font_secondary,
    fontSize: `${customPage?.heading_size_secondary}px`,
  };
  const subHeadingSecondaryStyle = {
    color: customPage?.sub_heading_color_secondary || websiteTextColor || '#1d2228',
    fontFamily: customPage?.sub_heading_font_secondary,
    fontSize: `${customPage?.sub_heading_size_secondary}px`,
  };
  const descriptionColorSecondary = customPage?.description_color_secondary || websiteTextColor || '#515151'
  const ImageUrlSecondary = customPage?.image_secondary_url
  const headingThirdStyle = {
    color: customPage?.heading_color_third || websiteTextColor || themeColor,
    fontFamily: customPage?.heading_font_third,
    fontSize: `${customPage?.heading_size_third}px`,
  };
  const subHeadingThirdStyle = {
    color: customPage?.sub_heading_color_third || websiteTextColor || '#1d2228',
    fontFamily: customPage?.sub_heading_font_third,
    fontSize: `${customPage?.sub_heading_size_third}px`,
  };
  const descriptionColorThird = customPage?.description_color_third || websiteTextColor || '#515151'
  const ImageUrlThird = customPage?.image_third_url
  const showPage = customPage?.show_first_section !== undefined ? customPage?.show_first_section : true

  const OpenPopup = () => {
    setIsModalVisible(true);
  }

  const onCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {!isHomePage && showPage &&
        <div className="section" style={{ backgroundColor: websiteBackgroundColor }}>
          <div className="container">
            <div className="row align-items-center">
              {ImageUrl &&
                <div className="col-lg-6 mb-lg-30 ct-single-img-wrapper" style={{ textAlign: 'center' }}>
                  <img
                    src={ImageUrl}
                    alt="img"
                  />
                  <div className="ct-dots" />
                </div>
              }
              <div className="col-lg-6">
                <Alert show={show} key="success" variant="success">
                  Email sent successfully
                </Alert>
                <div className="section-title-wrap mr-lg-30">
                  <h5 className="custom-primary" style={headingStyle}>
                    {customPage?.heading}
                  </h5>
                  <h2 className="title" style={subHeadingStyle}>
                    {customPage?.sub_heading}
                  </h2>
                  <p className="subtitle" style={{ color: descriptionColor }}>
                    {customPage?.description}
                  </p>
                  {customPage?.call_to_action_url && (
                    <a
                      href={customPage?.call_to_action_url}
                      hidden={!customPage?.call_to_action_url}
                      className="btn-header btn-section-first btn-footer"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {customPage?.call_to_action_button_text}
                    </a>
                  )}
                  {customPage?.show_contact_form && (
                    <>
                      {/*eslint no-script-url: "off"*/}
                      <a
                        href="javascript:void(0)"
                        className="btn-header btn-section-first btn-footer"
                        onClick={OpenPopup}
                        rel="noreferrer"
                      >
                        {customPage?.call_to_action_button_text || 'Contact Us'}
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {customPage?.show_secondary_section &&
        <div className="section" style={{ backgroundColor: websiteBackgroundColor }}>
          <div className="container">
            <div className="row align-items-center">
              {ImageUrlSecondary &&
                <div className="col-lg-6 mb-lg-30 ct-single-img-wrapper show-mobile-view" style={{ textAlign: 'center' }}>
                  <img
                    src={ImageUrlSecondary}
                    alt="img"
                  />
                  <div className="ct-dots" />
                </div>
              }
              <div className="col-lg-6">
                <div className="section-title-wrap mr-lg-30">
                  <h5 className="custom-primary" style={headingSecondaryStyle}>
                    {customPage?.heading_secondary}
                  </h5>
                  <h2 className="title" style={subHeadingSecondaryStyle}>
                    {customPage?.sub_heading_secondary}
                  </h2>
                  <p className="subtitle" style={{ color: descriptionColorSecondary }}>
                    {customPage?.description_secondary}
                  </p>
                  {customPage?.heading && customPage?.call_to_action_url_secondary && (
                    <a
                      href={customPage?.call_to_action_url_secondary}
                      hidden={!customPage?.call_to_action_url_secondary}
                      className="btn-header btn-section-second btn-footer"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {customPage?.call_to_action_button_text_secondary}
                    </a>
                  )}
                  {!customPage?.heading && customPage?.call_to_action_url_second && (
                    <a
                      href={customPage?.call_to_action_url_second}
                      hidden={!customPage?.call_to_action_url_second}
                      className="btn-header btn-section-second btn-footer"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {customPage?.call_to_action_button_text_second}
                    </a>
                  )}
                </div>
              </div>
              {ImageUrlSecondary &&
                <div className="col-lg-6 mb-lg-30 ct-single-img-wrapper show-desktop-view" style={{ textAlign: 'center' }}>
                  <img
                    src={ImageUrlSecondary}
                    alt="img"
                  />
                  <div className="ct-dots" />
                </div>
              }
            </div>
          </div>
        </div>
      }
      {customPage?.show_third_section &&
        <div className="section" style={{ backgroundColor: websiteBackgroundColor }}>
          <div className="container">
            <div className="row align-items-center">
              {ImageUrlThird &&
                <div className="col-lg-6 mb-lg-30 ct-single-img-wrapper" style={{ textAlign: 'center' }}>
                  <img
                    src={ImageUrlThird}
                    alt="img"
                  />
                  <div className="ct-dots" />
                </div>
              }
              <div className="col-lg-6">
                <div className="section-title-wrap mr-lg-30">
                  <h5 className="custom-primary" style={headingThirdStyle}>
                    {customPage?.heading_third}
                  </h5>
                  <h2 className="title" style={subHeadingThirdStyle}>
                    {customPage?.sub_heading_third}
                  </h2>
                  <p className="subtitle" style={{ color: descriptionColorThird }}>
                    {customPage?.description_third}
                  </p>
                  {customPage?.call_to_action_url_third && (
                    <a
                      href={customPage?.call_to_action_url_third}
                      hidden={!customPage?.call_to_action_url_third}
                      className="btn-header btn-section-third btn-footer"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {customPage?.call_to_action_button_text_third}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <ContactForm
        visible={isModalVisible}
        onCancel={onCancel}
        business={businessCode}
        setShow={setShow}
        websiteBackgroundColor={websiteBackgroundColor}
      />
    </>
  );
};

export default Section;
